module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><path d=\"M6.6 17.6l4.4-1.1-3.3-3.3z\"/><path d=\"M16 19.3l-1.1.7H2.7l-.7-.7V2.7l.7-.7H15l1 .7v.6l1.6-1.9L15.9 0H1.8C1.1 0 0 1.1 0 1.7v18.5c0 .7 1.1 1.8 1.7 1.8h14.1c.6 0 2.1-1.2 2.1-1.7v-8.2l-2 2.2v5z\"/><path d=\"M12.075 15.375l-3.322-3.324 9.902-9.897 3.323 3.325z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/edit.svg
// module id = 38
// module chunks = 0